<div class="rl-page lm-page">

  <!-- ── Page Header ──────────────────────────────────── -->
  <div class="lm-page-header">
    <button class="lm-back-btn" (click)="navigateBack()" [title]="'leave_management.avail_gift_of_time_page.title.back' | transloco">
      <mat-icon>{{ 'leave_management.avail_gift_of_time_page.arrow_back' | transloco }}</mat-icon>
    </button>
    <span class="lm-page-title">{{ 'leave_management.avail_gift_of_time_page.avail_gift_of_time' | transloco }}</span>
  </div>

  <lm-loading-overlay [show]="isLoading" message="Loading..."></lm-loading-overlay>
  <lm-loading-overlay [show]="isSubmitting" message="Submitting..."></lm-loading-overlay>

  <!-- ── Main Card ───────────────────────────────────── -->
  <div class="lm-card rl-card">
    <div class="rl-layout">

      <!-- ════════════════ LEFT SECTION ════════════════ -->
      <div class="rl-left">

        <!-- Gift Balance Banner -->
        <div class="got-avail-banner">
          Gift of Time (available Balance): {{ giftedBalance.balanceRemaining }}
        </div>

        <!-- Expiry Warning -->
        @if (expiresInDays !== null && expiresInDays <= 30) {
        <div class="got-expiry-warning">
          Expiring in {{ expiresInDays }} {{ expiresInDays === 1 ? 'day' : 'days' }}
        </div>
        }

        <form [formGroup]="availForm" class="rl-form">

          <!-- Submit Request To -->
          <div class="lm-form-group">
            <label class="lm-field-label">Submit Request to <span class="lm-req">*</span></label>
            <lib-ers-searchable-select
              formControlName="requestToId"
              [options]="managers"
              optionValue="id"
              optionLabel="name"
              emptyOptionLabel="{{ 'leave_management.avail_gift_of_time_page.select' | transloco }}"
              (selectionChange)="onManagerChange($event.value)"
            ></lib-ers-searchable-select>
            @if (selectedManager) {
            <div class="lm-chip-row">
              <span class="lm-chip">
                {{ selectedManager.name }}
                <button class="lm-chip-x" (click)="removeManager()" type="button">×</button>
              </span>
            </div>
            }
          </div>

          <!-- Start Date -->
          <div class="lm-form-group">
            <label class="lm-field-label">Start Date <span class="lm-req">*</span></label>
            <mat-form-field appearance="outline" class="lm-full-width">
              <input matInput [matDatepicker]="startPicker" formControlName="startDate"
                     readonly placeholder="MM/DD/YYYY">
              <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
            </mat-form-field>
          </div>

          <!-- End Date -->
          <div class="lm-form-group">
            <label class="lm-field-label">End Date <span class="lm-req">*</span></label>
            <mat-form-field appearance="outline" class="lm-full-width">
              <input matInput [matDatepicker]="endPicker" formControlName="endDate"
                     readonly placeholder="MM/DD/YYYY">
              <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
          </div>

          <!-- Description -->
          <div class="lm-form-group">
            <label class="lm-field-label">{{ 'leave_management.avail_gift_of_time_page.description' | transloco }}</label>
            <mat-form-field appearance="outline" class="lm-full-width">
              <textarea matInput formControlName="description" rows="4"
                        [placeholder]="'leave_management.avail_gift_of_time_page.placeholder.optional_description' | transloco"></textarea>
            </mat-form-field>
          </div>

        </form>

        <!-- Footer Buttons -->
        <div class="rl-form-footer">
          <button class="lm-btn lm-btn--reset" type="button" (click)="onReset()">{{ 'leave_management.avail_gift_of_time_page.reset' | transloco }}</button>
          <button class="lm-btn lm-btn--success" type="button" (click)="onSubmit()" [disabled]="isSubmitting">
            @if (isSubmitting) { <span class="lm-btn-spinner"></span> }
            {{ isSubmitting ? 'Submitting...' : 'Submit Request' }}
          </button>
        </div>

      </div>

      <!-- ════════════════ RIGHT SECTION ════════════════ -->
      <ers-leave-holiday-panel
        [companyHolidayRows]="companyHolidayRows"
        [optionalHolidayRows]="optionalHolidayRows"
        [pendingWorkedRows]="pendingWorkedRows"
        [holidayColDefs]="holidayColDefs"
        [workedDateColDefs]="workedDateColDefs">
      </ers-leave-holiday-panel>
    </div>
  </div>
</div>
